import { BigNumber } from '@ethersproject/bignumber';
import { ChainId, getNetworkConfig } from '@veno-app/wallet';

import { QueryKey } from './queryKey';

const rpcMap = {
  [ChainId.Mainnet]: 'https://cronos.org/explorer/api',
  [ChainId.Testnet]: 'https://cronos.org/explorer/testnet3/api',
  [ChainId.Dryrun]: 'https://cronos.org/explorer/dryrun/api',
} as const;

type BlockNumberRes = {
  result: string;
  id: number;
};
export const getBlockNumber = () => ({
  queryKey: [QueryKey.FETCH_BLOCK_NUMBER],
  queryFn: async () => {
    const fetchResponse = await fetch(
      `${
        rpcMap[getNetworkConfig().chainId as ChainId]
      }?module=block&action=eth_block_number`,
    );
    const response = (await fetchResponse.json()) as BlockNumberRes;

    return BigNumber.from(response.result);
  },
});
